export default __webpack_public_path__ + "a07a8fa3ebc66851dc76a20699b6f36d.svg";